import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../components/ExportToExcel";
import Pagination from "../../../components/Pagination";
import SearchBar from "../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Dynamic_FilterForm from "../../../components/Dynamic_FilterForm";
import { FaSpinner } from "react-icons/fa";

const CurrentOpportunity_table = ({
  data,
  selectedResource,
  selectAllChecked,
  isApiStatus,
  isRequiredStatus,
  isSrNoRequired,
  columns,
  defaultColumns,
  handleReset,
  handleBtn,
  // itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleIconClick,
  handleModalColumn,
  icons,
  isActionRequired,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleGetData,
  handleAddNew,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns({
      ...visibleColumns,
      [columnName]: !visibleColumns[columnName],
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  const sortedData = useMemo(() => {
    let sortableItems = [...(data || [])];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const valA = a[sortConfig.key] ? String(a[sortConfig.key]) : "";
        const valB = b[sortConfig.key] ? String(b[sortConfig.key]) : "";

        // Split the values into alphabetical and numeric parts
        const partsA = valA.match(/(\D+|\d+)/g) || [];
        const partsB = valB.match(/(\D+|\d+)/g) || [];

        for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
          const partA = partsA[i] || "";
          const partB = partsB[i] || "";

          // Determine if parts are numeric or alphabetical
          const isNumericA = !isNaN(partA);
          const isNumericB = !isNaN(partB);

          if (isNumericA && isNumericB) {
            // Both parts are numeric, so compare as numbers
            const numA = parseInt(partA, 10);
            const numB = parseInt(partB, 10);
            if (numA !== numB) {
              return sortConfig.direction === "ascending"
                ? numA - numB
                : numB - numA;
            }
          } else if (isNumericA || isNumericB) {
            // One part is numeric and the other is alphabetical
            return isNumericA ? -1 : 1;
          } else {
            // Both parts are alphabetical, so compare as strings
            if (partA !== partB) {
              return sortConfig.direction === "ascending"
                ? partA.localeCompare(partB)
                : partB.localeCompare(partA);
            }
          }
        }

        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

  //old code for date fromat
  // const formatDate = (date) => {
  //   if (!date) return ""; // Handle null or undefined dates

  //   // Check if the date is already in DD-MM-YYYY format
  //   const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  //   if (dateRegex.test(date)) {
  //     return date;
  //   }

  //   return moment(date).format("DD-MMM-YYYY");
  // };

  //new updateed code for date fromat
  const formatDate = (date) => {
    if (!date) return ""; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
  };


  const recordsPerPageOption = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
    { value: filteredData.length, label: 'All' },
  ];

  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);

  // Calculate total pages based on the current `selectedRecordsPerPage`
  const totalPages = Math.ceil(filteredData.length / selectedRecordsPerPage);

  // Data to display for the current page
  const currentPageData = filteredData.slice(
    (currentPage - 1) * selectedRecordsPerPage,
    currentPage * selectedRecordsPerPage
  );

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };


  const formatDateOrReturnText = (input) => {
    if (!input) return '';
  
    // If it's a number or numeric string with 4 digits and not a date-like format, return as-is
    if (/^\d{1,4}$/.test(input)) {
      return input; // Prevents mistaking year/amount as a date
    }
  
    let parsedDate = moment(input, "YYYY-MM-DD", true);
    if (parsedDate.isValid()) return parsedDate.format("DD-MMM-YYYY");
  
    parsedDate = moment(
      input,
      [
        "DD-MM-YYYY",
        "MM/DD/YYYY",
        "DD/MM/YYYY",
        "DD-MMM-YYYY",
        "DD-MM-YY",
        "MMM DD, YYYY",
        "YYYYMMDD",
        moment.ISO_8601,
      ],
      true
    );
  
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : input;
  };

  return (
    <div>
    <div className="container-fluid p-0">
  {/* Mobile layout (hidden on desktop) */}
  <div className="row g-2 d-flex d-md-none" style={{ marginBottom: "-30px" }}>
    <div className="col-10">
      <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
    </div>
    {isFilterRequired && (
      <div className="col-2 dropdown">
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
        >
          <button
            className="dropdown-toggle"
            type="button"
            id="excel-btn"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bi bi-funnel-fill"></i>
          </button>
        </OverlayTrigger>
        <div>
          <Dynamic_FilterForm
            formData={formDatas || []}
            handleChange={handleChange}
            handleGetData={handleGetData}
            handleReset={handleReset}
            filterFormData={filterFormData}
          />
        </div>
      </div>
    )}
  </div>

  {/* Mobile action buttons (hidden on desktop) */}
  <div className="row g-2 mb-2 d-flex d-md-none justify-content-end">
    <div className="col-auto">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
      >
        <div>
          <ExportToExcel data={filteredData} filename="InternalOpenings.csv" />
        </div>
      </OverlayTrigger>
    </div>
    <div className="col-auto">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
      >
        <div className="btn-group" style={{ zIndex: 100 }}>
          <button
            type="button"
            className="dropdown-toggle skill-button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="excel-btn"
          >
            <i className="bi bi-list"></i>
          </button>
          <ul className="dropdown-menu p-2">
            <div className="row" style={{ maxHeight: "300px", overflowY: "auto" }}>
              <Form.Group style={{ width: "250px" }}>
                {Object.keys(visibleColumns).map((columnName) => (
                  <Form.Check
                    key={columnName}
                    type="checkbox"
                    id={`checkbox-${columnName}`}
                    label={columnName}
                    checked={visibleColumns[columnName]}
                    onChange={() => toggleColumn(columnName)}
                  />
                ))}
              </Form.Group>
            </div>
          </ul>
        </div>
      </OverlayTrigger>
    </div>
    {isAddNewBtnRequired && (
      <div className="col-auto">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
        >
          <button id="Add-btn" onClick={handleAddNew}>
            <i className="fa fa-plus"></i> Add
          </button>
        </OverlayTrigger>
      </div>
    )}
  </div>

  {/* Desktop layout (hidden on mobile) */}
  <div className="d-none d-md-flex justify-content-between">
    <div className="d-flex">
      <div className="me-1">
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      </div>
      {isFilterRequired && (
        <div className="dropdown">
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
          >
            <button
              className="dropdown-toggle"
              type="button"
              id="excel-btn"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="bi bi-funnel-fill"></i>
            </button>
          </OverlayTrigger>
          <div>
            <Dynamic_FilterForm
              formData={formDatas || []}
              handleChange={handleChange}
              handleGetData={handleGetData}
              handleReset={handleReset}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      )}
    </div>

    <div className="d-flex justify-content-end">
      <div className="me-1">
        <ExportToExcel data={filteredData} filename="InternalOpenings.csv" />
      </div>
      <div className="btn-group me-2" style={{ zIndex: 100 }}>
        <button
          type="button"
          className="dropdown-toggle skill-button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          id="excel-btn"
        >
          <i className="bi bi-list"></i>
        </button>
        <ul className="dropdown-menu p-2">
          <div className="row" style={{ maxHeight: "300px", overflowY: "auto" }}>
            <Form.Group style={{ width: "250px" }}>
              {Object.keys(visibleColumns).map((columnName) => (
                <Form.Check
                  key={columnName}
                  type="checkbox"
                  id={`checkbox-${columnName}`}
                  label={columnName}
                  checked={visibleColumns[columnName]}
                  onChange={() => toggleColumn(columnName)}
                />
              ))}
            </Form.Group>
          </div>
        </ul>
      </div>
      {isAddNewBtnRequired && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
        >
          <button id="Add-btn" onClick={handleAddNew}>
            <i className="fa fa-plus"></i> Add
          </button>
        </OverlayTrigger>
      )}
    </div>
  </div>
</div>

      <div className="table-responsive">
        <Table striped hover bordered>
          <thead id="thcolor" className="text-center">
            <tr>
              {isCheckBoxRequired && (
                <th style={{ width: "25px" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectAllChecked}
                    onChange={(e) => handleSelectAllChange(e)}
                  />
                </th>
              )}
              {Object.keys(columns).map((columnName) => {
                   const isDateColumn = 
                    columns[columnName].text
                  

                const columnAlignment = columns[columnName].align || "left";
                const columnWidth = columns[columnName].width;

                const isButtonColumn = columns[columnName].type === "button";
                const isModalColumn = columns[columnName].type === "Modal";
                const isImageColumn = columns[columnName].type === "Image";
                const hasIcon = columns[columnName].icon;
                console.log("hasIcon", hasIcon);


                return (
                  visibleColumns[columnName] && (
                    <th
                      style={{ whiteSpace: "nowrap" }}
                      key={columnName}
                      onClick={
                        isSorting &&
                          (isButtonColumn || isModalColumn || hasIcon)
                          ? undefined
                          : () => handleSort(columnName)
                      }
                    >
                      {columns[columnName].text}
                      {isSorting &&
                        !(isButtonColumn || isModalColumn || hasIcon) && (
                          <span className="ms-1">
                            {sortConfig.key === columnName ? (
                              sortConfig.direction === "ascending" ? (
                                <i className="bi bi-chevron-up"></i>
                              ) : (
                                <i className="bi bi-chevron-down"></i>
                              )
                            ) : (
                              <i className="bi bi-chevron-down"></i>
                            )}
                          </span>
                        )}
                    </th>
                  )
                );
              })}
              {isActionRequired && <th>Action</th>}
            </tr>
          </thead>
          {isRequiredStatus && (
            isApiStatus === 200 && currentData?.length !== 0 ? (
              <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    {isCheckBoxRequired && (
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={!!selectedResource.find((o) => o.EmployeeID === item.EmployeeID)}
                          onChange={(e) => handleCheckboxChange(e, item.EmployeeID, item)}
                        />
                      </td>
                    )}
                    {Object.keys(columns).map((columnName) => {
                      const isButtonColumn = columns[columnName].type === "button";
                      const isButtonName = columns[columnName].text;
                      const shouldShowTooltip = item[columnName] && !isButtonColumn;
                      const columnAlignment = columns[columnName].align || "left";
                      const hasIcon = columns[columnName].icon;
    const isDateColumn = 
                    columns[columnName].text
                  
                      return (
                        visibleColumns[columnName] && (
                          <td
                            key={columnName}
                            className={`text-${columnAlignment} text-truncate`} style={{
                              maxWidth: columns[columnName].width || "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {shouldShowTooltip ? (
                              <OverlayTrigger
                                placement="auto"
                                overlay={<Tooltip id={`tooltip-${columnName}`}>{item[columnName]}</Tooltip>}
                              >
                                <span> {isDateColumn
                                      ? formatDateOrReturnText(item[columnName])
                                      : formatDateOrReturnText(item[columnName])}</span>
                              </OverlayTrigger>
                            ) : isButtonColumn ? (
                              <button
                                className={item?.ShowStatus === "" ? "custom-btn" : "custom-disable-btn"}
                                onClick={() => handleBtn(columnName, item)}
                                disabled={item?.ShowStatus !== ""}
                              >
                                {isButtonName}
                              </button>
                            ) : hasIcon ? (
                              <div
                                className="d-flex align-items-center justify-content-center text-center"
                                onClick={() =>
                                  handleIconClick(columnName, item)
                                }
                              >
                                <span className="me-2">
                                  {icons[columns[columnName].icon]}
                                </span>
                                {item[columnName]}
                              </div>
                            ) : item[columnName] ? (
                                  formatDateOrReturnText(item[columnName])
                                ):"-"}
                          </td>
                        )
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            ) : isApiStatus === 200 && currentData?.length === 0 ? (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      Object.keys(columns).length +
                      (isCheckBoxRequired ? 1 : 0) +
                      (isActionRequired ? 1 : 0)
                    }
                    className="text-center"
                  >
                    <p>No Data Found</p>
                  </td>
                </tr>
              </tbody>
            ) : isApiStatus === undefined && currentData?.length === 0 ? (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      Object.keys(columns).length +
                      (isCheckBoxRequired ? 1 : 0) +
                      (isActionRequired ? 1 : 0) +
                      (isSrNoRequired ? 1 : 0)
                    }
                    className="text-center"
                  >
                    <div>
                      <p>
                        <FaSpinner className="spinner" />
                        <br />
                        Loading
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : currentData?.length !== 0 ? (
              <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    {isCheckBoxRequired && (
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={!!selectedResource.find((o) => o.EmployeeID === item.EmployeeID)}
                          onChange={(e) => handleCheckboxChange(e, item.EmployeeID, item)}
                        />
                      </td>
                    )}
                    {Object.keys(columns).map((columnName) => {
                      const isButtonColumn = columns[columnName].type === "button";
                      const isButtonName = columns[columnName].text;
                      const shouldShowTooltip = item[columnName] && !isButtonColumn;
                      const columnAlignment = columns[columnName].align || "left";

                      return (
                        visibleColumns[columnName] && (
                          <td
                            key={columnName}
                            className={`text-${columnAlignment} text-truncate`} style={{
                              maxWidth: columns[columnName].width || "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {shouldShowTooltip ? (
                              <OverlayTrigger
                                placement="auto"
                                overlay={<Tooltip id={`tooltip-${columnName}`}>{item[columnName]}</Tooltip>}
                              >
                                <span>{item[columnName]}</span>
                              </OverlayTrigger>
                            ) : isButtonColumn ? (
                              <button
                                className={item?.ShowStatus === "" ? "custom-btn" : "custom-disable-btn"}
                                onClick={() => handleBtn(columnName, item)}
                                disabled={item?.ShowStatus !== ""}
                              >
                                {isButtonName}
                              </button>
                            ) : (
                              item[columnName]
                            )}
                          </td>
                        )
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      Object.keys(columns).length +
                      (isCheckBoxRequired ? 1 : 0) +
                      (isActionRequired ? 1 : 0) +
                      (isSrNoRequired ? 1 : 0)
                    }
                    className="text-center"
                  >
                    <div>
                      <p>
                        <FaSpinner className="spinner" />
                        <br />
                        Loading
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            )
          )}

        </Table>
           </div>
        {/* {filteredData.length > itemsPerPage && ( */}
     <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-3">
  {/* Text and per-page dropdown - stacked on small screens, inline on larger screens */}
  <div className="d-flex justify-content-between px-2">
    <span style={{ width: "150px" }}>
      Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{' '}
      {Math.min(currentPage * selectedRecordsPerPage, filteredData.length)} of {filteredData.length}
    </span>

    <div style={{ width: "80px" }}>
      <select
        value={selectedRecordsPerPage}
        onChange={handleRecordsPerPage}
        className="mx-2 form-select form-select-sm"
      >
        {recordsPerPageOption.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  </div>

  {/* Pagination - centered on small screens, right-aligned on larger screens */}
  <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-100">
    <Pagination
      itemsPerPage={selectedRecordsPerPage}
      totalItems={filteredData.length}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  </div>
</div>
        {/* )} */}
   
    </div>
  );
};

export default CurrentOpportunity_table;
